import { render, staticRenderFns } from "./add-discuss-drawer.vue?vue&type=template&id=94aafb3e&scoped=true"
import script from "./add-discuss-drawer.vue?vue&type=script&lang=js"
export * from "./add-discuss-drawer.vue?vue&type=script&lang=js"
import style0 from "./add-discuss-drawer.vue?vue&type=style&index=0&id=94aafb3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aafb3e",
  null
  
)

export default component.exports